import { useState } from 'react';
import { X } from 'lucide-react';
import { Input } from '../../../components/ui/input';
import { Button } from '../../../components/ui/button';
import { Badge } from '../../../components/ui/badge';
import { sanitizeUsername, canAddCollaborator, MAX_COLLABORATORS } from '../../../shared/lib/instagramTags';

interface CollaboratorsInputProps {
  value: string[];
  onChange: (next: string[]) => void;
}

export function CollaboratorsInput({ value, onChange }: CollaboratorsInputProps) {
  const [draft, setDraft] = useState('');

  const add = () => {
    // Keep the draft on invalid/duplicate input so the user can fix it; only clear on success.
    if (!canAddCollaborator(value, draft)) return;
    onChange([...value, sanitizeUsername(draft)]);
    setDraft('');
  };

  const remove = (index: number) => onChange(value.filter((_, i) => i !== index));

  const atLimit = value.length >= MAX_COLLABORATORS;

  return (
    <div className="space-y-2">
      <p className="text-sm font-medium">Соавторы (до {MAX_COLLABORATORS})</p>
      <div className="flex flex-wrap gap-2">
        {value.map((name, index) => (
          <Badge key={`${name}-${index}`} variant="secondary" className="gap-1">
            @{name}
            <button type="button" onClick={() => remove(index)} aria-label={`Удалить ${name}`}>
              <X className="h-3 w-3" />
            </button>
          </Badge>
        ))}
      </div>
      {!atLimit && (
        <div className="flex gap-2">
          <Input
            value={draft}
            placeholder="username"
            onChange={(e) => setDraft(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                e.preventDefault();
                add();
              }
            }}
          />
          <Button type="button" variant="outline" onClick={add}>
            Добавить
          </Button>
        </div>
      )}
    </div>
  );
}
